import React from 'react';

import { Waypoint } from 'react-waypoint';

import { Indicator as LoadingIndicator } from '../common/container/Loading.jsx';
import { Input } from '../common/input/Text.jsx';

class Search extends React.Component {
    constructor(props) {
        super(props);

        let q;
        const temp = Artcloud.util.getparameterbyname('q');
        if (temp && temp.length > 0) {
            q = temp;
        }
        this.state = {
            results: {
                loading: false,
                q: {
                    limit: 10,
                    offset: 0,
                    q: q
                }
            },
        };

        this._handleSearchInputRef = this._handleSearchInputRef.bind(this);
        this.getResults = this.getResults.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleSearchInlineClear = this.handleSearchInlineClear.bind(this);
        this.handleSearchSubmit = this.handleSearchSubmit.bind(this);
        this.handleWaypointEnter = this.handleWaypointEnter.bind(this);
    }

    componentDidMount() {
        this.getResults();

        const component = this;
        component._handleSearchInline = _.debounce(function (q, abort) {
            if (abort == true) {
                return;
            }
            if (component.inlineRequest) {
                component.inlineRequest.abort();
                component.inlineRequest = null;
            }
            component.inlineRequest = Artcloud.api.get(
                Artcloud.url.vendor.marketplace.forms.searches.get(),
                { limit: 5, offset: 0, q: q },
                function (responseData) {
                    component.inlineRequest = null;

                    component.setState({
                        inlineResults: {
                            data: responseData.Results,
                            more: responseData.More
                        }
                    });
                },
                function (jqXHR, textStatus) {
                    component.inlineRequest = null;
                    Artcloud.api.fail(jqXHR, textStatus);
                }
            );
        }, 250);
    }

    componentWillUnmount() {
        if (this.inlineRequest) {
            this.inlineRequest.abort();
            this.inlineRequest = null;
        }
        if (this.request) {
            this.request.abort();
            this.request = null;
        }
    }

    _handleSearchInputRef(ref) {
        this.searchInputRef = ref;
    }

    getResults() {
        const component = this;
        const state = component.state.results;
        if (state.loading) {
            return;
        }
        state.loading = true;
        component.setState({
            results: state
        });
        component.request = Artcloud.api.get(
            Artcloud.url.vendor.marketplace.forms.searches.get(),
            state.q,
            function (responseData) {
                component.request = null;

                let data = state.data || [];
                state.data = data.concat(responseData.Results);

                state.q.offset += responseData.Results.length;
                state.total = responseData.Total;

                state.loading = false;
                component.setState({
                    results: state
                });
            },
            function (jqXHR, textStatus) {
                component.request = null;

                state.loading = false;
                component.setState({
                    results: state
                });
                Artcloud.api.fail(jqXHR, textStatus);
            }
        );
    }

    handleSearchChange(name, value) {
        const state = this.state.results;
        state.q[name] = value;
        this.setState({
            results: state
        });

        this._handleSearchInline(value);
    }

    handleSearchInlineClear(event) {
        if (event) {
            event.preventDefault();
        }

        this.setState({
            inlineResults: undefined
        });
    }

    handleSearchSubmit(event) {
        if (event) {
            event.preventDefault();
        }

        // Cancel pending inline search requests
        this._handleSearchInline(null, true);
        if (this.inlineRequest) {
            this.inlineRequest.abort();
            this.inlineRequest = null;
        }
        const q = this.state.results.q.q;
        this.setState({
            inlineResults: undefined,
            results: {
                q: {
                    limit: 10,
                    offset: 0,
                    q: q
                }
            }
        }, this.getResults);

        if (this.searchInputRef) {
            this.searchInputRef.blur();
        }

        if (window.history.replaceState) {
            window.history.replaceState(null, null, `${location.origin}${location.pathname}?q=${q}`);
        }
    }

    handleWaypointEnter() {
        if (!this.state.results.data || (this.state.results.data && this.state.results.q.offset >= this.state.results.total)) {
            return;
        }
        this.getResults();
    }

    render() {
        let results;
        if (this.state.results.data) {
            results = this.state.results.data.map(function (d, i) {
                if (d.Type && d.Type.Type == 1) {
                    return <ArtistSearchResult key={i} d={d} />
                }
                return <SearchResult key={i} d={d} />
            });
        }
        return (
            <section className="section section--search">
                <div className="search__container search--inner search--nav search--active">
                    <form className="search__inner container" onSubmit={this.handleSearchSubmit}>
                        <Input
                            autoComplete="off"
                            name="q"
                            placeholder="Search for artwork, artists and galleries"
                            type="text"
                            wrap={false}
                            value={this.state.results.q.q}
                            onChange={this.handleSearchChange}
                            onRef={this._handleSearchInputRef} />
                        <button className="search__submit" type="submit">
                            <span className="i i--arrow-right" />
                        </button>
                    </form>
                    {
                        this.state.inlineResults &&
                        this.state.inlineResults.data &&
                        <div className="search__drop">
                            <div className="container">
                                {this.state.inlineResults.data.map((d, i) => <SearchResultInline key={i} d={d} />)}
                                {
                                    this.state.inlineResults.more > 0 &&
                                    <a href="#" onClick={this.handleSearchSubmit} className="search__item search__item--results">
                                        <div className="search__item--results__num">
                                            {this.state.inlineResults.more}
                                        </div>
                                        <div className="search__item--results__text">more results...</div>
                                    </a>
                                }
                                {
                                    this.state.inlineResults.data.length == 0 &&
                                    <a href="#" onClick={this.handleSearchInlineClear}>
                                        <div className="search__item--results__text">0 results</div>
                                    </a>
                                }
                            </div>
                        </div>
                    }
                </div>
                <div className="container">
                    <div style={{ marginTop: '100px' }}>
                        {
                            results != undefined &&
                            <React.Fragment>
                                {
                                    results.length == 0 &&
                                    this.state.results.q.q &&
                                    this.state.results.q.q.length > 0 &&
                                    <div className="search__list search__list--dots">
                                        <div className="search__item__label">Oops</div>
                                        <h5 className="search__list__title">No results for "{this.state.results.q.q}"</h5>
                                    </div>
                                }
                                {
                                    results.length > 0 &&
                                    <div className="container--waypoint">
                                        {results}
                                        <div className="loading--waypoint">
                                            <Waypoint onEnter={this.handleWaypointEnter} />
                                        </div>
                                    </div>
                                }
                            </React.Fragment>
                        }
                        {
                            this.state.results.loading &&
                            <LoadingIndicator />
                        }
                    </div>
                </div>
            </section>
        );
    }
}

function SearchResult(props) {
    let className = 'search__list';
    if (props.className) {
        className += ' ' + props.className;
    }
    const d = props.d || {};
    let content, link;
    if (d.Type && d.Type.Type) {
        switch (d.Type.Type) {
            case 0: {
                // Artwork
                const object = d.Object || {};
                link = `/art/${object.Slug}`;

                let image;
                if (d.Image) {
                    image = Artcloud.cdn.url(d.Image.S3Id, null, 225);
                }
                content = (
                    <a href={link} className="search__list--artwork">
                        <div className="search__item__img__artwork" style={{ backgroundImage: image ? `url('${image}')` : undefined }} />
                        <span className="art__details">
                            <span>{object.Dimensions}</span>
                            <span>{object.DisplayPrice}</span>
                            {
                                object.Gallery &&
                                <span>{object.Gallery.Company}</span>
                            }
                        </span>
                    </a>
                )
                break;
            }
            case 1: {
                // Artist
                const object = d.Object || {};
                link = `/artist/${object.Slug}`;
                break;
            }
            case 2:
                // Show
                return null;
            case 3: {
                // City
                link = `/city/${d.Id}`;

                let image = '../assets/img/backgrounds/atl.jpg';
                if (d.Image) {
                    image = d.Image.MediumUrl;
                }
                const object = d.Object || {};
                content = (
                    <a href={link} className="search__list--gallery" >
                        <span className="search__item__img__gallery" style={{ backgroundImage: image ? `url('${image}')` : undefined }} />
                        <span className="search__list__content">
                            {
                                object.Galleries != undefined &&
                                <span className="search__list__label">{object.Galleries} Galler{object.Galleries.length == 1 ? 'y' : 'ies'}</span>
                            }
                            {
                                object.Artists != undefined &&
                                <span className="search__list__label">{object.Artists} Artist{object.Artists.length == 1 ? '' : 's'}</span>
                            }
                            {
                                object.Collectors != undefined &&
                                <span className="search__list__label">{object.Collectors} Collector{object.Collectors.length == 1 ? '' : 's'}</span>
                            }
                        </span>
                    </a >
                )
                break;
            }
            case 4: {
                // Gallery
                const object = d.Object || {};
                link = `/gallery/${object.Slug}`;

                let image;
                if (d.Image) {
                    image = Artcloud.cdn.url(d.Image.S3Id, null, 200);
                }
                let bio = object.Bio;
                if (bio && bio.length > 300) {
                    bio = bio.substring(0, 300) + '...';
                }
                content = (
                    <a href={link} className="search__list--gallery" >
                        <span className="search__item__img__gallery" style={{ backgroundImage: image ? `url('${image}')` : undefined }} />
                        <span className="search__list__content">
                            <span className="search__list__info" dangerouslySetInnerHTML={{__html: bio}}></span>
                            {
                                object.Location &&
                                object.Location.length > 0 &&
                                <span className="search__list__label">Based in: {object.Location}</span>
                            }
                        </span>
                    </a>
                );
                break;
            }
        }
    }
    return (
        <div className={className}>
            {
                d.Type &&
                <div className="search__item__label">{d.Type.Name}</div>
            }
            <a href={link}>
                <h5 className="search__list__title">{d.Result}</h5>
            </a>
            {content}
            {props.children}
        </div>
    );
}

class ArtistSearchResult extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

        this.getArtwork = this.getArtwork.bind(this);
    }

    componentDidMount() {
        this.getArtwork();
    }

    componentWillUnmount() {
        if (this.request) {
            this.request.abort();
            this.request = null;
        }
    }

    getArtwork() {
        if (!this.props.d || !this.props.d.Id) {
            return;
        }
        const component = this;
        component.setState({
            loading: true
        });
        component.request = Artcloud.api.get(
            Artcloud.url.vendor.marketplace.artists.art.get(component.props.d.Id),
            { limit: 6, offset: 0 },
            function (responseData) {
                component.request = null;

                component.setState({
                    loading: false,
                    results: responseData.Art
                });
            },
            function (jqXHR, textStatus) {
                component.request = null;

                component.setState({
                    loading: false,
                    results: []
                });
                Artcloud.api.fail(jqXHR, textStatus);
            }
        );
    }

    render() {
        return (
            <SearchResult {...this.props}>
                <div className="artist">
                    {
                        this.state.results &&
                        this.state.results.map((d) =>
                            <a key={d.ArtId} href={`/art/${d.Slug}`} className="search__list__user">
                                <div className="search__item__img" style={{ backgroundImage: (d.Image ? `url('${d.Image.SmallUrl}')` : undefined) }} />
                            </a>
                        )
                    }
                </div>
            </SearchResult>
        );
    }
}

function SearchResultInline(props) {
    const d = props.d || {};
    let image;
    if (d.Image) {
        image = d.Image.SmallUrl;
    }
    let link;
    if (d.Type && d.Type.Type) {
        switch (d.Type.Type) {
            case 0: {
                // Artwork
                const object = d.Object || {};
                link = `/art/${object.Slug}`;
                break;
            }
            case 1: {
                // Artist
                const object = d.Object || {};
                link = `/artist/${object.Slug}`;
                break;
            }
            case 2:
                // Show
                return null;
            case 3: {
                // City
                link = `/city/${d.Id}`;
                break;
            }
            case 4: {
                // Gallery
                const object = d.Object || {};
                link = `/gallery/${object.Slug}`;
                break;
            }
        }
    }
    return (
        <a href={link} className="search__item">
            <div className="search__item__img" style={{ backgroundImage: image ? `url('${image}')` : undefined }} />
            <div className="search__item__content">
                {
                    d.Type &&
                    <div className="search__item__label">{d.Type.Name}</div>
                }
                <div className="search__item__title">{d.Result}</div>
            </div>
        </a>
    );
}

export { ArtistSearchResult, Search };